import React from 'react'
import Text from '../Text'

const DisclaimerSection = ({ data }) => {
  const title = data?.title
  const description = data?.description

  return (
    <section className="w-full bg-white">
      <div className="max-w-[1024px] mx-auto px-4 py-2">
        <div className="flex items-center justify-center gap-3">
          <div className="space-y-1.5">
            <div className="bg-[linear-gradient(90deg,_#FFF_0%,_#E4E7EC_49.26%,_#FFF_100%)] h-px mb-2" />
            {title ? (
              <div className="flex items-center justify-center gap-2 text-[#98A2B3]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M6.68661 2.4392C7.25742 1.40732 8.74087 1.40731 9.31171 2.43917L14.4755 11.7735C15.0286 12.7732 14.3055 13.9996 13.163 13.9996H2.83565C1.69313 13.9996 0.970046 12.7733 1.52309 11.7735L6.68661 2.4392ZM8.66505 11.3339C8.66505 10.9662 8.36697 10.6681 7.99927 10.6681C7.63157 10.6681 7.3335 10.9662 7.3335 11.3339C7.3335 11.7015 7.63157 11.9996 7.99927 11.9996C8.36697 11.9996 8.66505 11.7015 8.66505 11.3339ZM8.49225 6.09834C8.45895 5.85432 8.2496 5.66638 7.99647 5.66659C7.72033 5.66681 7.49665 5.89084 7.49687 6.16699L7.49927 9.16805L7.50389 9.23589C7.53719 9.47992 7.74654 9.66785 7.99967 9.66765C8.27581 9.66743 8.49949 9.44339 8.49927 9.16725L8.49687 6.16619L8.49225 6.09834Z"
                    fill="#98A2B3"
                  />
                </svg>
                <Text variant="body" size="small" tag="p" bold="true">
                  {title}
                </Text>
              </div>
            ) : null}
            {description ? (
              <Text
                variant="body"
                size="small"
                tag="p"
                textalign="center"
                className="text-[#98A2B3]"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}

export default DisclaimerSection
